import {
  Box,
  Flex,
  Avatar,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuDivider,
  useColorModeValue,
  Stack,
  Center,
  Image
} from '@chakra-ui/react';
import React from 'react';
import { useAuth } from '../context/AuthContext'; // Import useAuth
import { useNavigate } from 'react-router-dom';
import { signOut } from '../apis/signOutApi';

const NavLink = (props) => {
  const { children } = props;

  return (
    <Box
      as="a"
      px={2}
      py={1}
      rounded={'md'}
      _hover={{
        textDecoration: 'none',
      }}
      href={'#'}>
      {children}
    </Box>
  );
};

export default function HeaderDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth(); // Use useAuth hook

  const firstname = user.user_metadata.firstname;
  const lastname = user.user_metadata.lastname;

  const logoutSubmit = async (e) => {
    e.preventDefault();
    signOut();
    navigate('/auth')
  };

  const handleProfileClick = (section = "profile") => {
    navigate('/personal', { state: { section } });
  };

  return (
    <>
      <Box bg={useColorModeValue('#87CEEB', '#87CEEB')} px={4}>
        <Flex h={16} alignItems={'center'} justifyContent={'space-between'}>
          <Image src="../birdiehouse_logo.svg" width="250px" height="50px" />

          <Flex alignItems={'center'}>
            <Stack direction={'row'} spacing={7}>
              <Menu>
                <MenuButton
                  as={Button}
                  rounded={'full'}
                  variant={'link'}
                  cursor={'pointer'}
                  minW={0}>
                  <Avatar
                    name={firstname + ' ' + lastname}
                    size={'sm'}
                    src={'https://bit.ly/broken-link'}
                  />
                </MenuButton>
                <MenuList alignItems={'center'}>
                  <br />
                  <Center>
                    <Avatar
                      name={firstname + ' ' + lastname}
                      size={'2xl'}
                      src={'https://bit.ly/broken-link'}
                    />
                  </Center>
                  <br />
                  <Center>
                    <p>{firstname + ' ' + lastname}</p>
                  </Center>
                  <br />
                  <MenuDivider />
                  <MenuItem onClick={() => handleProfileClick("profile")}>My Profile</MenuItem>
                  <MenuItem onClick={() => handleProfileClick("settings")}>Account Settings</MenuItem>
                  <MenuItem onClick={logoutSubmit}>Logout</MenuItem>
                </MenuList>
              </Menu>
            </Stack>
          </Flex>
        </Flex>
      </Box>
    </>
  );
}